import { OrderCourierEnum } from "@saleor/motherOrders/utils/enums";

interface MinutesField {
  any_status_minutes: number;
  collected_status_minutes: number;
  ready_status_minutes: number;
}
interface CourierField {
  courier: OrderCourierEnum;
}
interface StatusField {
  is_enabled: boolean;
}
interface StoreTypeField {
  store_type: string;
}

type ParamOldNew =
  | Partial<MinutesField>
  | Partial<CourierField>
  | Partial<StatusField>
  | Partial<StoreTypeField>;

interface Parameter {
  old: ParamOldNew;
  new: ParamOldNew;
  action: string;
}

export interface ExpressFleetUpdate {
  parameters: Parameter;
}

export const isExpressFleetUpdate = (obj: any): obj is ExpressFleetUpdate =>
  typeof obj === "object" && "parameters" in obj;

export const getTypeDisplayValue = (type: string): string =>
  type === "FOOD_AND_BEVERAGES"
    ? "Food & Beverage"
    : type === "GENERAL_MERCHANDISE"
    ? "General Merchandise"
    : type;
